import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_TABS_CONFIG, MatTabsModule } from '@angular/material/tabs';
import { BadgeModule } from '@sb/library/badge';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { UtilityModule } from '@sb/library/utility';
import { TabGroupBodyComponent } from './group/body/tab-group-body.component';
import { TabGroupHeaderComponent } from './group/header/tab-group-header.component';
import { StepProgressHeaderComponent } from './group/step-progress-header/step-progress-header.component';
import { TabGroupComponent } from './group/tab-group.component';
import { TabComponent } from './tab.component';

@NgModule({
    declarations: [
        TabComponent,
        TabGroupComponent,
        TabGroupHeaderComponent,
        TabGroupBodyComponent,
        StepProgressHeaderComponent
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        UtilityModule,
        IconModule,
        BaseModule,
        BadgeModule,
        ButtonModule
    ],
    exports: [
        TabComponent,
        TabGroupComponent,
        TabGroupHeaderComponent,
        TabGroupBodyComponent,
        StepProgressHeaderComponent
    ]
})
export class TabModule { }
